<template>
    <v-container>
        <v-dialog
                v-model="dialog_bloqueo"
                persistent
                width="500"
        >
            <v-card class="elevation-0">
                <v-toolbar class="mb-0" dark color="warning">
                    <v-toolbar-title>
                        {{$t('aviso')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <h2>{{$t('pagina_caduca')}}</h2>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_aceptar" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text>Para continuar es necesario Aceptar los <strong>Términos y Condiciones</strong>.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialog_aceptar = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_cellphone" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text>{{$t('cellphone_wrong')}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialog_cellphone = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_condiciones" scrollable persistent width="600px">
            <v-card align="justify">
                <v-card-title class="headline primary white--text">
                    Intrare
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-flex xs12>
                            <v-img
                                    class="centrado ml-4 mr-4 mt-3 mb-3"
                                    :src="language === 'es' ? require('../../assets/residencial_mx.png') : require('../../assets/residencial_eu.png')"
                                    height="250px"
                                    contain
                            ></v-img>
                        </v-flex>
                    </v-row>
                    <br>
                    <div><h2>Términos y Condiciones</h2></div>
                    <br>
                    <div class="body-2">
                        El presente documento establece las condiciones mediante las cuales se regirá el uso del
                        sistema y/o aplicación: INTRARE (en adelante el sistema), el cual es operado por
                        TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V. empresa constituida en
                        México y domiciliada en la ciudad de San Luis Potosí, S.L.P. y que en adelante se
                        identificara por su nombre comercial “INTRARE”
                    </div>
                    <br>
                    <div class="body-2">
                        INTRARE es un sistema digital de acceso que facilita la identificación y agiliza el proceso
                        de ingreso de visitantes, proveedores, empleados y trabajadores domésticos a diversos
                        polígonos, dejando un registro de fecha y hora de salida.
                    </div>
                    <br>
                    <div class="body-2">
                        INTRARE cuenta con submarcas que a su vez encuadran áreas específicas en las que se
                        aplicaran los servicios del sistema, por lo que el usuario podrá encontrarse con las
                        siguientes denominaciones dentro del sistema: a) Intrare Residencia, b)Intrare Empresa,
                        c)Intrare Construcción, d)Intrare Escuela.
                    </div>
                    <br>
                    <div class="body-2">
                        El usuario se compromete a leer los términos y condiciones aquí establecidas, previamente
                        al uso del sistema, por tanto, en caso de realizar la instalación se entiende que cuenta con
                        el conocimiento integral de este documento y la consecuente aceptación de la totalidad de
                        sus estipulaciones.
                    </div>
                    <br>
                    <div class="body-2">
                        El Usuario reconoce que el ingreso de su información personal y los datos que contiene el
                        sistema a su disposición lo realizan de manera voluntaria, quienes optan por acceder a este
                        sistema en México o desde fuera del territorio nacional, lo hacen por iniciativa propia y son
                        responsables del cumplimiento de las leyes locales, en la medida en que dichas leyes sean
                        aplicables en su correspondiente país. En caso de que se acceda por parte de menores de
                        edad, deben contar con la supervisión de un adulto en todo momento desde la instalación
                        y durante el uso del sistema, en el evento en que no se cumpla esta condición, le
                        agradecemos no hacer uso del sistema.
                    </div>
                    <br>
                    <div class="subtitle-1"><strong>Alcance y Uso</strong></div>
                    <br>
                    <div class="body-2">
                        El usuario del sistema entiende y acepta que es operado por TECNOLOGÍAS EN
                        ACCESOS CONTROLADOS SA DE CV., la información contenida en el mismo será la
                        referente a su vínculo comercial o contractual con la empresa.
                    </div>
                    <br>
                    <div class="body-2">
                        Los tiempos de respuesta, tramites y demás solicitudes efectuadas por el usuario mediante
                        el sistema serán procesadas de conformidad con las especificaciones de cada producto
                        activo con INTRARE.
                    </div>
                    <br>
                    <div class="body-2">
                        El usuario acepta y autoriza que los registros electrónicos de las actividades mencionadas,
                        que realice en el sistema constituyen plena prueba de los mismos.
                    </div>
                    <br>
                    <div class="subtitle-1"><strong>Requisitos para Uso</strong></div>
                    <br>
                    <div class="body-2">
                        El usuario deberá contar con un dispositivo móvil inteligente (Smartphone) o Tableta con
                        sistema operativo Android o IOS o un ordenador, cualquiera de estos con acceso a internet,
                        ambos seguros y confiables. INTRARE, no será responsable por la seguridad de los
                        equipos Smartphone propiedad de los usuarios utilizados para el acceso al sistema, ni por
                        la disponibilidad del servicio en los dispositivos en los cuales se descargue el sistema.
                    </div>
                    <br>
                    <div class="body-2">
                        En la forma permitida por la ley, los materiales del sistema se suministran sin garantía de
                        ningún género, expresa o implícitamente, incluyendo sin limitación las garantías de calidad
                        satisfactoria, comerciabilidad, adecuación para un fin particular o no infracción, por tanto,
                        INTRARE no garantiza el funcionamiento adecuado en los distintos sistemas operativos o
                        dispositivos en los cuales se haga uso del sistema.
                    </div>
                    <br>
                    <div class="body-2">
                        Para acceder al portal, EL CLIENTE contará con Usuario y Clave, que lo identifica en su
                        relación con INTRARE. Adicional a lo anterior se requerirá a EL CLIENTE, al momento de
                        acceder al sistema que ingrese su nombre de usuario y contraseña.
                    </div>
                    <br>
                    <div class="subtitle-1"><strong>Obligaciones de los Usuarios</strong></div>
                    <br>
                    <div class="body-2">
                        El Usuario se obliga a usar el sistema y los contenidos encontrados en ella de una manera
                        diligente, correcta, lícita y en especial, se compromete a NO realizar las conductas descritas
                        a continuación:
                    </div>
                    <br>
                    <div class="body-2">
                        (a) Utilizar los contenidos de forma, con fines o efectos contrarios a la ley, a la moral y a las
                        buenas costumbres generalmente aceptadas o al orden público;
                    </div>
                    <br>
                    <div class="body-2">
                        (b) Reproducir, copiar, representar, utilizar, distribuir, transformar o modificar los contenidos
                        del sistema, por cualquier procedimiento o sobre cualquier soporte, total o parcial, o permitir
                        el acceso del público a través de cualquier modalidad de comunicación pública;
                    </div>
                    <br>
                    <div class="body-2">
                        (c) Utilizar los contenidos de cualquier manera que entrañen un riesgo de daño o
                        inutilización del sistema o de los contenidos o de terceros;
                    </div>
                    <br>
                    <div class="body-2">
                        (d) Suprimir, eludir o manipular el derecho de autor y demás datos identificativos de los
                        derechos de autor incorporados a los contenidos, así como los dispositivos técnicos de
                        protección, o cualesquiera mecanismos de información que pudieren tener los contenidos;
                    </div>
                    <br>
                    <div class="body-2">
                        (e) Emplear los contenidos y, en particular, la información de cualquier clase obtenida a
                        través de del sistema para distribuir, transmitir, remitir, modificar, rehusar o reportar la
                        publicidad o los contenidos de esta con fines de venta directa o con cualquier otra clase de
                        finalidad comercial, mensajes no solicitados dirigidos a una pluralidad de personas con
                        independencia de su finalidad, así como comercializar o divulgar de cualquier modo dicha
                        información;
                    </div>
                    <br>
                    <div class="body-2">
                        (f) No permitir que terceros ajenos a usted usen el sistema con su clave;
                    </div>
                    <br>
                    <div class="body-2">
                        (g) Utilizar el sistema y los contenidos con fines lícitos y/o ilícitos, contrarios a lo establecido
                        en estos Términos y Condiciones, o al uso mismo del sistema, que sean lesivos de los
                        derechos e intereses de terceros, o que de cualquier forma puedan dañar, inutilizar,
                        sobrecargar o deteriorar el sistema y los contenidos o impedir la normal utilización o disfrute
                        de esta y de los contenidos por parte de los usuarios.
                    </div>
                    <br>
                    <div class="subtitle-1"><strong>Propiedad Intelectual</strong></div>
                    <br>
                    <div class="body-2">
                        Todo el material informático, gráfico, publicitario, fotográfico, de multimedia, audiovisual y
                        de diseño, así como todos los contenidos, textos y bases de datos puestos a su disposición
                        en este sistema están protegidos por derechos de autor y/o propiedad industrial cuyo titular
                        es TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V. Igualmente, el uso en el
                        sistema de algunos materiales de propiedad de terceros se encuentra expresamente
                        autorizado por la ley o por dichos terceros. Todos los contenidos en el sistema están
                        protegidos por las normas sobre derecho de autor y por todas las normas nacionales e
                        internacionales que le sean aplicables.
                    </div>
                    <br>
                    <div class="body-2">
                        Exceptuando lo expresamente estipulado en estos Términos y Condiciones, queda
                        prohibido todo acto de copia, reproducción, modificación, creación de trabajos derivados,
                        venta o distribución, exhibición de los contenidos de este sistema, de manera o por medio
                        alguno, incluyendo, más no limitado a, medios electrónicos, mecánicos, de fotocopiado, de
                        grabación o de cualquier otra índole, sin el permiso previo y por escrito de INTRARE o del
                        titular de los respectivos derechos.
                    </div>
                    <br>
                    <div class="body-2">
                        En ningún caso estos Términos y Condiciones confieren derechos, licencias ni
                        autorizaciones para realizar los actos anteriormente prohibidos. Cualquier uso no
                        autorizado de los contenidos constituirá una violación del presente documento y a las
                        normas vigentes sobre derechos de autor, a las normas vigentes nacionales e
                        internacionales sobre Propiedad Industrial, y a cualquier otra que sea aplicable.
                    </div>
                    <br>
                    <div class="subtitle-1"><strong>Licencia para Copiar para Uso Personal</strong></div>
                    <br>
                    <div class="body-2">
                        Usted podrá leer, visualizar, imprimir y descargar el material que integra el sistema.
                    </div>
                    <br>
                    <div class="body-2">
                        Ninguna parte del sistema podrá ser reproducida o transmitida o almacenada en otro sitio
                        web o en otra forma de sistema de recuperación electrónico.
                    </div>
                    <br>
                    <div class="body-2">
                        Ya sea que se reconozca específicamente o no, las marcas comerciales, las marcas de
                        servicio y los logos visualizados en este sistema pertenecen a TECNOLOGÍAS EN
                        ACCESOS CONTROLADOS S.A. DE C.V., sus socios promocionales u otros terceros.
                    </div>
                    <br>
                    <div class="body-2">
                        INTRARE no interfiere, no toma decisiones, ni garantiza las relaciones que los usuarios
                        lleguen a sostener o las vinculaciones con terceros que pauten y/o promocionen sus
                        productos y servicios. Estas marcas de terceros se utilizan solamente para identificar los
                        productos y servicios de sus respectivos propietarios y el patrocinio o el aval por parte de
                        INTRARE no se deben inferir con el uso de estas marcas comerciales.
                    </div>
                    <br>
                    <div class="subtitle-1"><strong>Integración con Otras Aplicaciones</strong></div>
                    <br>
                    <div class="body-2">
                        INTRARE podrá enlazarse por medio de links con otras aplicaciones como por ejemplo
                        Facebook, Google, Gmail, One Drive , etc. Lo anterior con el fin de poder sincronizar
                        calendarios y wallets.
                    </div>
                    <br>
                    <div class="body-2">
                        INTRARE trata de suministrar enlaces a sitios y aplicaciones de terceros que cumplan con
                        las leyes y regulaciones aplicables y las normas de INTRARE, el Usuario debe entender
                        que INTRARE no tiene control sobre la naturaleza y el contenido de esos sitios y no está
                        recomendando estos sitios, la información que contienen ni los productos o servicios de
                        terceros.
                    </div>
                    <br>
                    <div class="body-2">
                        INTRARE no acepta responsabilidad por el contenido del sitio de un tercero con el cual
                        existe un link de hipertexto y no ofrece garantía (explícita o implícita) en cuanto al contenido
                        de la información en esos sitios, ya que no recomienda estos sitios.
                    </div>
                    <br>
                    <div class="body-2">
                        Usted debe verificar las secciones de términos y condiciones, política legal y de privacidad
                        de algunos otros sitios que con los cuales INTRARE se enlaza.
                    </div>
                    <br>
                    <div class="body-2">
                        INTRARE no asume ninguna responsabilidad por pérdida directa, indirecta o consecuencial
                        por el uso de un sitio de un tercero.
                    </div>
                    <br>
                    <div class="subtitle-1"><strong>Uso de Información y Privacidad</strong></div>
                    <br>
                    <div class="body-2">
                        Con la descarga del sistema usted acepta y autoriza que TECNOLOGÍAS EN ACCESOS
                        CONTROLADOS S.A. DE C.V., utilice sus datos en calidad de responsable del tratamiento
                        para fines derivados de la ejecución del sistema. TECNOLOGÍAS EN ACCESOS
                        CONTROLADOS S.A. DE C.V. informa que podrá ejercer sus derechos a conocer,
                        actualizar, rectificar y suprimir su información personal; así como el derecho a revocar el
                        consentimiento otorgado para el tratamiento de datos personales previstos en la ley,
                        observando nuestro Aviso de Privacidad mismo que se establece en nuestra página
                        www.intrare.com.mx ; o a través de holas@intrare.app.
                    </div>
                    <br>
                    <div class="body-2">
                        TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V. podrá dar a conocer,
                        transferir y/o trasmitir sus datos personales dentro y fuera del país a terceros a
                        consecuencia de un contrato, ley o vínculo lícito que así lo requiera, para todo lo anterior
                        otorgo mi autorización expresa e inequívoca.
                    </div>
                    <br>
                    <div class="subtitle-1"><strong>Responsabilidad de INTRARE</strong></div>
                    <br>
                    <div class="body-2">
                        INTRARE procurará garantizar disponibilidad, continuidad o buen funcionamiento del
                        sistema. INTRARE podrá bloquear, interrumpir o restringir el acceso a esta cuando lo
                        considere necesario para el mejoramiento del sistema o por dada de baja de la misma.
                    </div>
                    <br>
                    <div class="body-2">
                        Se recomienda al Usuario tomar medidas adecuadas y actuar diligentemente al momento
                        de acceder al sistema, como, por ejemplo, contar con programas de protección, antivirus,
                        para manejo de malware, spyware y herramientas similares.
                    </div>
                    <br>
                    <div class="body-2">
                        INTRARE no será responsable por: a) Fuerza mayor o caso fortuito; b) Por la pérdida,
                        extravío o hurto de su dispositivo móvil u ordenador que implique el acceso de terceros a al
                        sistema; c) Por errores en la digitación o accesos por parte del cliente; d) Por los perjuicios,
                        lucro cesante, daño emergente, morales, y en general sumas a cargo de INTRARE,
                        derivados de los retrasos, no procesamiento de información o suspensión del servicio del
                        operador móvil o daños en los dispositivos móviles.
                    </div>
                    <br>
                    <div class="subtitle-1"><strong>Pagos</strong></div>
                    <br>
                    <div class="body-2">
                        INTRARE no recibe ni gestiona pagos por medio del sistema. Todo lo relacionado a
                        contratación y pagos se maneja de forma externa entre TECNOLOGÍAS EN ACCESOS
                        CONTROLADOS S.A. DE C.V. y el Cliente por otros medios.
                    </div>
                    <br>
                    <div class="subtitle-1"><strong>Denegación y Retirada del Acceso al Sistema</strong></div>
                    <br>
                    <div class="body-2">
                        En el Evento en que un Usuario incumpla estos Términos y Condiciones, o cualesquiera
                        otras disposiciones que resulten de aplicación, INTRARE podrá suspender su acceso al
                        sistema.
                    </div>
                    <br>
                    <div class="subtitle-1"><strong>Términos y Condiciones</strong></div>
                    <br>
                    <div class="body-2">
                        El Usuario acepta expresamente los Términos y Condiciones, siendo condición esencial
                        para la utilización de este sistema. En el caso en que se encuentre en desacuerdo con estos
                        Términos y Condiciones, solicitamos abandonar el sistema inmediatamente. INTRARE
                        podrá modificar los presentes términos y condiciones, avisando a los usuarios del sistema
                        mediante publicación en la página web www.intrare.com.mx o mediante la difusión de las
                        modificaciones por algún medio electrónico, redes sociales, SMS y/o correo electrónico, lo
                        cual se entenderá aceptado por el usuario si éste continua con el uso del sistema.
                    </div>
                    <br>
                    <div class="subtitle-1"><strong>Jurisdicción</strong></div>
                    <br>
                    <div class="body-2">
                        Estos términos y condiciones y todo lo que tenga que ver con este sistema, se rigen por las
                        leyes Mexicanas y los Tratados Internacionales de los que forma parte México. Para
                        cualquier solución de conflictos que pudieran resultar del uso del sistema, las partes se
                        someten a la jurisdicción de los tribunales de la Ciudad de San Luis Potosí, S.L.P.,
                        renunciando a cualquiera otra que por domicilio les corresponda.
                    </div>
                    <br>
                    <div class="subtitle-1"><strong>Uso de Información no Personal</strong></div>
                    <br>
                    <div class="body-2">
                        INTRARE también recolecta información no personal en forma agregada para seguimiento
                        de datos como el número total de accesos al sistema, instalación, descarga, etc. Utilizamos
                        esta información, que permanece en forma agregada, para entender el comportamiento del
                        sistema y poder mejorar el servicio del mismo.
                    </div>
                    <br>
                    <div class="subtitle-1"><strong>Uso de Direcciones IP</strong></div>
                    <br>
                    <div class="body-2">
                        Una dirección de Protocolo de Internet (IP) es un conjunto de números que se asigna
                        automáticamente a su o dispositivo móvil u ordenador cuando usted accede a su proveedor
                        de servicios de internet, o a través de la red de área local (LAN) de su organización o la red
                        de área amplia (WAN). Los servidores web automáticamente identifican su dispositivo móvil
                        u ordenador por la dirección IP asignada a él durante su sesión en línea.
                    </div>
                    <br>
                    <div class="body-2">
                        INTRARE podrán recolectar direcciones IP para propósitos de administración de sistemas
                        y para auditar el uso de nuestro sistema, todo lo anterior de acuerdo con la autorización de
                        protección de datos que se suscribe para tal efecto. Normalmente no vinculamos la
                        dirección IP de un usuario con la información personal de ese usuario, lo que significa que
                        cada sesión de usuario se registra, pero el usuario sigue siendo anónimo para nosotros.
                        Sin embargo, podemos usar las direcciones IP para identificar a los usuarios de nuestro
                        sistema cuando sea necesario con el objeto de exigir el cumplimiento de los términos de
                        uso del sistema, o para proteger nuestro servicio, sitio u otros usuarios.
                    </div>
                    <br>
                    <div class="subtitle-1"><strong>Seguridad</strong></div>
                    <br>
                    <div class="body-2">
                        INTRARE está comprometido en la protección de la seguridad de su información personal.
                        INTRARE tiene implementados mecanismos de seguridad que aseguran la protección de
                        la información personal, así como los accesos únicamente al personal y sistemas
                        autorizados, también contra la pérdida, uso indebido y alteración de sus datos de usuario
                        bajo nuestro control.
                    </div>
                    <br>
                    <div class="body-2">
                        Excepto como se indica a continuación, sólo personal autorizado tiene acceso a la
                        información que nos proporciona. Además, hemos impuesto reglas estrictas a los
                        empleados de INTRARE con acceso a las bases de datos que almacenan información del
                        usuario o a los servidores que hospedan nuestros servicios.
                      </div>
                    <v-col class="text-right">
                      <v-btn color="primary" @click="dialog_condiciones = false">{{$t('aceptar')}}</v-btn>
                    </v-col>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogCutIdFront" persistent scrollable max-width="1000px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperFront"
                            :src="imageIneFrenteURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="dialogCutIdFront = false, getCutIdFront()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogCutIdBack" persistent scrollable max-width="1000px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperBack"
                            :src="imageIneAtrasURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="dialogCutIdBack = false, getCutIdBack()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogCutProfile" persistent scrollable max-width="1000px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            class="basic lg"
                            :src="imageFotoFrenteURL"
                            ref="clipperProfile"
                            :rotate="degrees"
                            :round="true"
                            preview="preview">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="dialogCutProfile = false, getCutProfile()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-layout align-center justify-center fill-height>
            <v-card class="elevation-5">
                <v-toolbar dark class="mb-5" color="primary">
                    <v-toolbar-title>
                        {{$t('preregistro')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="mt-4">
                    <v-row>
                        <v-flex xs12>
                            <v-img
                                    class="centrado ml-4 mr-4"
                                    :src="language === 'es' ? require('../../assets/residencial_mx.png') : require('../../assets/residencial_eu.png')"
                                    height="250px"
                                    contain
                            ></v-img>
                        </v-flex>
                    </v-row>
                    <v-form class="mb-4"
                            @submit.prevent="preregistro()">
                        <v-layout row wrap>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="first_name"
                                        prepend-icon="mdi-account"
                                        name="first_name"
                                        :label="$t('Nombre')"
                                        :error-messages="errores.first_name"
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 >
                                <v-text-field
                                        v-model="last_name"
                                        prepend-icon="mdi-account-outline"
                                        name="last_name"
                                        :label="$t('Apellido')"
                                        :error-messages="errores.last_name"
                                >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="email"
                                        prepend-icon="mdi-email"
                                        name="email"
                                        label="E-Mail"
                                        :error-messages="errores.email"
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <vue-phone-number-input
                                        default-country-code="MX"
                                        color="#D32F2F"
                                        valid-color="#2a2738"
                                        @update="onChange"
                                        v-model="celular"
                                        :translations="custom_cell_phone"
                                >
                                </vue-phone-number-input>
                                <v-alert v-if="errores.cellNumber" type="error">{{errores.cellNumber}}</v-alert>
                            </v-flex>
                        </v-layout>
                        <br>
                        <v-layout row wrap>
                            <v-flex class="edge pt-3 pb-3 pl-3 pr-3" xs12 sm6>
                                <v-label>
                                    {{$t('foto_ine')}}<br>[{{$t('frente')}}]
                                </v-label>
                                <br>
                                <v-img
                                        class="pt-3 pb-3"
                                        :src="resultIneFrenteURL"
                                        v-if="resultIneFrenteURL"
                                        width="auto"
                                        height="180"
                                ></v-img>
                                <br>
                                <v-alert
                                        v-if="errores.idFront"
                                        type="error"
                                        outlined
                                        transition="scale-transition"
                                >
                                    {{errores.idFront}}
                                </v-alert>
                                <br>
                                <v-btn
                                        color="primary">
                                    <clipper-upload
                                            @input="dialogCutIdFront = true, degrees = 0, ratio = '1'"
                                            accept="image/*"
                                            v-model="imageIneFrenteURL"
                                    >
                                        {{$t('subir_imagen')}}
                                    </clipper-upload>
                                </v-btn>
                            </v-flex>
                            <v-flex class="edge pt-3 pb-3 pl-3 pr-3" xs12 sm6>
                                <v-label>
                                    {{$t('foto_ine')}}<br>[{{$t('reverso')}}]
                                </v-label>
                                <br>
                                <v-img
                                        class="pt-3 pb-3"
                                        :src="resultIneAtrasURL"
                                        v-if="resultIneAtrasURL"
                                        width="auto"
                                        height="180"
                                ></v-img>
                                <br>
                                <v-alert
                                        v-if="errores.idBack"
                                        type="error"
                                        outlined
                                        transition="scale-transition"
                                >
                                    {{errores.idBack}}
                                </v-alert>
                                <br>
                                <v-btn
                                        color="primary">
                                    <clipper-upload
                                            @input="dialogCutIdBack = true, degrees = 0, ratio = '1'"
                                            accept="image/*"
                                            v-model="imageIneAtrasURL"
                                    >
                                        {{$t('subir_imagen')}}
                                    </clipper-upload>
                                </v-btn>
                            </v-flex>
                            <v-flex class="edge pt-3 pb-3 pl-3 pr-3" xs12 sm6>
                                <div class="splash-info">
                                    <v-label>
                                        {{$t('foto_perfil')}}
                                    </v-label>
                                    <br>
                                    <div class="wrapper">
                                        <img
                                                :src="resultFotoFrenteURL"
                                                v-if="resultFotoFrenteURL">
                                    </div>
                                    <br>
                                    <v-alert
                                            v-if="errores.avatar"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores.avatar}}
                                    </v-alert>
                                    <br>
                                    <v-btn
                                            color="primary">
                                        <clipper-upload
                                                @input="dialogCutProfile = true, degrees = 0, ratio = '1'"
                                                accept="image/*"
                                                v-model="imageFotoFrenteURL"
                                        >{{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 align="justify">
                                <small>Para poder continuar con el Proceso de Preregistro es necesario
                                    <strong>Aceptar</strong> nuestros <strong>Términos y Condiciones</strong>,
                                    los cuales puede consultar dando click en la siguiente liga:
                                    <a @click="dialog_condiciones = true">Términos y Condiciones</a>.
                                </small>
                                <v-checkbox
                                        v-model="checkbox_aceptar"
                                        label="Aceptar Términos y Condiciones"
                                ></v-checkbox>
                            </v-flex>
                        </v-layout>
                        <v-alert
                                :value=alerta
                                type="warning"
                                outlined
                                transition="scale-transition"
                        >
                            Fallo con el Servidor
                        </v-alert>
                        <v-btn
                                color="primary"
                                type="submit"
                                :loading="loading"
                        >
                            {{$t('enviar')}}
                        </v-btn>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import '@/plugins/axios'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import Vue from 'vue'
import { mapState } from 'vuex'
import VuejsClipper from 'vuejs-clipper'

Vue.component('vue-phone-number-input', VuePhoneNumberInput)

Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})
export default {
  name: 'preregistration',
  data () {
    return {
      alerta: false,
      first_name: '',
      last_name: '',
      celular: '',
      email: '',
      errores: [],
      loading: false,
      dialogCutIdFront: false,
      dialogCutIdBack: false,
      dialogCutProfile: false,
      dialog_condiciones: false,
      resultIneFrenteURL: '',
      resultIneAtrasURL: '',
      resultFotoFrenteURL: '',
      imageIneFrenteURL: '',
      imageIneAtrasURL: '',
      imageFotoFrenteURL: '',
      checkbox_aceptar: false,
      dialog_aceptar: false,
      dialog_bloqueo: false,
      dialog_cellphone: false,
      custom_cell_phone: { },
      band_cellphone: false,
      cellphone_plus_country_code: '',
      idUser: 0,
      degrees: 0,
      ratio: '1'
    }
  },
  created: function () {
    this.get_info_new_guest()
  },
  beforeUpdate () {
    this.custom_cell_phone = {
      'countrySelectorLabel': this.$t('codigo_pais'),
      'phoneNumberLabel': this.$t('celular'),
      'example': this.$t('ejemplo')
    }
  },
  computed: {
    ...mapState(['language'])
  },
  methods: {
    clear: function () {
      this.$store.commit('snackbar_activate_false')
    },
    onChange (data) {
      this.cellphone_plus_country_code = data.formattedNumber
      this.band_cellphone = data.isValid
    },
    preregistro: function () {
      if (this.checkbox_aceptar === true && this.band_cellphone === true) {
        this.loading = true
        var bodyFormData = new FormData()
        var file = null
        var file2 = null
        var file3 = null
        bodyFormData.set('first_name', this.first_name)
        bodyFormData.set('last_name', this.last_name)
        bodyFormData.set('cellNumber', this.cellphone_plus_country_code)
        bodyFormData.set('email', this.email)
        bodyFormData.set('username', this.email)
        bodyFormData.set('temporalToken', '')
        bodyFormData.set('is_active', true)
        if (this.resultIneFrenteURL !== '' && this.resultIneFrenteURL.length > 6) {
          file = this.dataURLtoFile(this.resultIneFrenteURL, 'picture.jpeg')
        }
        bodyFormData.append('idFront', file)
        if (this.resultIneAtrasURL !== '' && this.resultIneAtrasURL.length > 6) {
          file3 = this.dataURLtoFile(this.resultIneAtrasURL, 'picture2.jpeg')
        }
        bodyFormData.append('idBack', file3)
        if (this.resultFotoFrenteURL !== '' && this.resultFotoFrenteURL.length > 6) {
          file2 = this.dataURLtoFile(this.resultFotoFrenteURL, 'avatar.jpeg')
        }
        bodyFormData.append('avatar', file2)
        const config = {
          method: 'put',
          url: 'https://clubtest.intrare.app/users/non_active/update/' + this.idUser,
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept-Language': this.language
          },
          data: bodyFormData
        }
        axios(config)
          .then(ok => {
            this.loading = false
            this.$router.push({ path: '/register/success' })
          })
          .catch(error => {
            if (error.response && error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            } else {
              if (error.response.status === 404) {
                this.$store.commit('snackbar_activate_true')
                this.$store.commit('snackbar_change_color', 'error')
                this.$store.commit('snackbar_change_message', 'Token Inválido')
                setTimeout(this.clear, 3000)
              }
            }
          })
          .finally(() => (this.loading = false))
      } else {
        if (this.checkbox_aceptar === false) {
          this.dialog_aceptar = true
        } else {
          this.dialog_cellphone = true
        }
      }
    },
    get_info_new_guest: function () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/users/non_active/' + this.$route.params['token'],
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language
        }
      }
      axios(config)
        .then(ok => {
          this.idUser = ok.data.id
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 404) {
            this.dialog_bloqueo = true
          }
        })
        .finally(() => (this.loading = false))
    },
    getCutIdFront: function () {
      const canvas = this.$refs.clipperFront.clip() // call component's clip method
      this.resultIneFrenteURL = canvas.toDataURL('image/jpeg', 0.2)// canvas->image
    },
    getCutIdBack: function () {
      const canvas = this.$refs.clipperBack.clip() // call component's clip method
      this.resultIneAtrasURL = canvas.toDataURL('image/jpeg', 0.2)// canvas->image
    },
    getCutProfile: function () {
      const canvas = this.$refs.clipperProfile.clip() // call component's clip method
      this.resultFotoFrenteURL = canvas.toDataURL('image/jpeg', 0.2)// canvas->image
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #2a2738 #2a2738 #2a2738 #2a2738;
        border-width: 3px 3px 3px 3px;
        text-align: center;
        border-style: solid solid solid solid;
    }
    .wrapper{
        width:200px;
        height:200px;
        position: relative;
        margin: 25px auto;
        overflow: hidden;
        border-radius:50%;
        border: 5px solid #2a2738;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
    .splash-info {
        background: #ffffff;
        position: relative;
        z-index: 2;
        margin-bottom: 30px;
        text-align: center;
        font-size:15px;
        font-weight:bold;
    }
</style>
